import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { showModal } from 'redux/modules/modals';

export const mapDispatchToProps = {
  showModal,
};

export class ShowModalUnwrapped extends PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(...args) {
    const { modalName, modalProps, onClick, showModal: localShowModal } = this.props;

    if (onClick) {
      onClick(...args);
    }

    localShowModal(modalName, modalProps);
  }

  render() {
    const { className, children } = this.props;

    return (
      <span className={classNames('qa-button', className)} onClick={this.handleClick}>
        {children}
      </span>
    );
  }
}

ShowModalUnwrapped.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  modalName: PropTypes.string.isRequired,
  modalProps: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  showModal: PropTypes.func.isRequired,
};

const reduxDecorator = connect(
  null,
  mapDispatchToProps
);

export const ShowModal = reduxDecorator(ShowModalUnwrapped);
